// extracted by mini-css-extract-plugin
export default {"scrollTabs":"styles_scrollTabs__+YtJU"};